import { LockClosedIcon, LockOpenIcon } from '@repo/ui/icons'
import Lock from '@repo/ui/lock'
import Modal from '@repo/ui/modal'
import { useMutation } from '@tanstack/react-query'
import React, { useState } from 'react'

import { lockTripFolder } from '../../api/trip-folder/lock-trip-folder'
import { unlockTripFolder } from '../../api/trip-folder/unlock-trip-folder'
import { showAxiosError } from '../../lib/utils/functions/misc.functions'

type Props = {
  id: number
  label: string
  locked: boolean
  onSuccess?: () => void
  className?: string
  isTableLoading?: boolean
}

const TripFolderLock: React.FC<Props> = ({
  id,
  label,
  locked,
  onSuccess,
  className,
  isTableLoading = false
}) => {
  const [isConfirmOpen, setIsConfirmOpen] = useState(false)

  const handleSuccess = () => {
    setIsConfirmOpen(false)
    onSuccess?.()
  }

  const { mutate: lockFn, isPending: isLocking } = useMutation({
    mutationFn: lockTripFolder,
    onSuccess: handleSuccess,
    onError: showAxiosError
  })

  const { mutate: unlockFn, isPending: isUnlocking } = useMutation({
    mutationFn: unlockTripFolder,
    onSuccess: handleSuccess,
    onError: showAxiosError
  })

  const loading = isLocking || isUnlocking || isTableLoading

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation()
    setIsConfirmOpen(true)
  }

  return (
    <>
      <Lock isLocked={locked} loading={loading} onClick={handleClick} className={className} />
      {/* stop clicks inside the modal from reaching the table row (row click opens the folder) */}
      <div className="contents" onClick={(e) => e.stopPropagation()}>
        <Modal
          isOpen={isConfirmOpen}
          variant="confirmation"
          icon={locked ? LockOpenIcon : LockClosedIcon}
          title={`Êtes-vous sûr de vouloir ${locked ? 'déverrouiller' : 'verrouiller'} le(s) dossier(s) voyage suivant(s) : ${label} ?`}
          isLoading={isLocking || isUnlocking}
          actionButtonsOptions={{
            confirmText: 'Oui',
            cancelText: 'Retour',
            onConfirm: () => {
              if (locked) unlockFn(id)
              else lockFn(id)
            }
          }}
          onCancel={() => setIsConfirmOpen(false)}
        />
      </div>
    </>
  )
}

export default TripFolderLock
